
import "./MenuPdfButton.css";

export default function MenuPdfButton() {
    return (
        <div className="menu-pdf-wrapper">
            <a href="/menu.pdf" target="_blank" rel="noopener noreferrer" className="menu-pdf-button">
                Apri il menu PDF
            </a>
        </div>
    );
}